import { v4 as uuidv4 } from 'uuid';
import { CreateRedirectionCampaignConstant } from '../constant';

const initialState = {
  type: '',
  general: null,
  audiences: [],
  segments: [],
  selectedChannels: [],
  openedChannel: '',
  openedCampaign: '',
  openedAudience: '',
  openedSegment: '',
  openedCampaignEndDate: '',
  openedCampaignStartDate: '',
  experienceKeys: {},
};

let tmpAudiences = [];
let tmpSegments = [];
let tmpSegment;
let removedChannelArr = [];
let removedAudienceArr = [];
let removedChannel = null;

export default function createRedirectionCampaignReducers(
  state = initialState,
  action
) {
  switch (action.type) {
    case CreateRedirectionCampaignConstant.ADD_EXPERIENCE_KEYS: {
      return {
        ...state,
        experienceKeys: action.payload,
      };
    }

    case CreateRedirectionCampaignConstant.ADDAUDIENCE: {
      return {
        ...state,
        audiences: [{ ...action.payload, id: uuidv4() }, ...state.audiences],
      };
    }

    case CreateRedirectionCampaignConstant.UPDATEAUDIENCE: {
      tmpAudiences = [
        { ...action.payload },
        ...state.audiences.filter((ele) => ele?.id != action?.payload?.id),
      ];
      return {
        ...state,
        audiences: tmpAudiences,
      };
    }

    case CreateRedirectionCampaignConstant.REMOVEAUDIENCE: {
      return {
        ...state,
        audiences: state.audiences.filter((ele) => ele?.id != action.key),
        segments: state.segments?.filter((ele) => ele?.audience != action?.key),
      };
    }

    case CreateRedirectionCampaignConstant.ADDSEGMENT: {
      return {
        ...state,
        segments: [{ ...action.payload, id: uuidv4() }, ...state.segments],
      };
    }

    case CreateRedirectionCampaignConstant.UPDATESEGMENT: {
      const findIndex = state.segments.findIndex(
        (ele) => ele?.id == action?.payload?.id
      );
      const newSegment = [...state.segments];
      if (findIndex > -1) {
        newSegment[findIndex] = {
          ...newSegment[findIndex],
          ...action?.payload,
        };
      }
      return {
        ...state,
        segments: newSegment,
      };
    }

    case CreateRedirectionCampaignConstant.REMOVESEGMENT: {
      return {
        ...state,
        segments: state.segments.filter((ele) => ele?.id != action.key),
      };
    }

    case CreateRedirectionCampaignConstant.SETSELECTEDCHANNELS: {
      tmpAudiences = state.audiences;
      tmpSegments = state.segments;
      removedChannelArr = state.selectedChannels?.filter(
        ({ value: chl1 }) =>
          !action.payload.some(({ value: chl2 }) => chl1 === chl2)
      );
      if (removedChannelArr?.length > 0) {
        removedChannel = removedChannelArr[0];
        tmpAudiences = removedChannel
          ? state.audiences?.filter(
              (ele, i) => ele.channel != removedChannel?.value
            )
          : state.audiences;

        removedAudienceArr = state?.audiences?.filter(
          ({ id: audId1 }) =>
            !tmpAudiences.some(({ id: audId2 }) => audId1 === audId2)
        );
        tmpSegments =
          removedChannel && removedAudienceArr?.length > 0
            ? state.segments?.filter(
                ({ audience: audId1 }) =>
                  !removedAudienceArr?.some(
                    ({ id: audId2 }) => audId1 === audId2
                  )
              )
            : state.segments;
      }

      return {
        ...state,
        selectedChannels: action.payload,
        audiences: tmpAudiences,
        segments: tmpSegments,
      };
    }

    case CreateRedirectionCampaignConstant.SETOPENEDCAMPAIGN: {
      return {
        ...state,
        openedCampaign: action.openedCampaign,
      };
    }

    case CreateRedirectionCampaignConstant.SETOPENEDCHANNEL: {
      return {
        ...state,
        openedChannel: action.key,
      };
    }

    case CreateRedirectionCampaignConstant.SETOPENEDAUDIENCE: {
      return {
        ...state,
        openedAudience: action.key,
      };
    }

    case CreateRedirectionCampaignConstant.SETOPENEDSEGMENT: {
      return {
        ...state,
        openedSegment: action.key,
      };
    }

    case CreateRedirectionCampaignConstant.SETOPENEDCAMPAIGNENDDATE: {
      return {
        ...state,
        openedCampaignEndDate: action.openedCampaignEndDate,
      };
    }

    case CreateRedirectionCampaignConstant.SETOPENEDCAMPAIGNSTARTDATE: {
      return {
        ...state,
        openedCampaignStartDate: action.openedCampaignStartDate,
      };
    }

    case CreateRedirectionCampaignConstant.SAVECONTENTMAPPING: {
      tmpSegment = { ...state.segments.find((seg) => seg.id == action.key) };
      tmpSegments = [
        { ...tmpSegment, ...action.payload },
        ...state.segments.filter((ele) => ele?.id != action?.key),
      ];
      return {
        ...state,
        segments: tmpSegments,
      };
    }

    case CreateRedirectionCampaignConstant.CLEARALL: {
      return {
        ...state,
        general: null,
        audiences: [],
        segments: [],
        selectedChannels: [],
        openedChannel: '',
        openedCampaign: '',
        openedAudience: '',
        openedSegment: '',
        type: CreateRedirectionCampaignConstant.CLEARALL,
      };
    }

    case CreateRedirectionCampaignConstant.SETAUDIENCES: {
      return {
        ...state,
        audiences: action.payload,
      };
    }

    case CreateRedirectionCampaignConstant.SETSEGMENTS: {
      return {
        ...state,
        segments: action.payload,
      };
    }

    default:
      return state;
  }
}
